<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="me-2 mb-2">
            <input
              type="month"
              class="form-control"
              v-model="filters.period"
              @change="fetchReport"
            />
          </div>

          <div class="mb-2">
            <div class="dropdown">
              <a
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    href="javascript:void(0);"
                    @click.prevent="exportCsv"
                  v-can="'Reports.Export'"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as CSV
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    href="javascript:void(0);"
                    @click.prevent="exportPdf"
                  v-can="'Reports.Export'"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <!-- <li>
                  <a
                    class="dropdown-item rounded-1"
                    href="javascript:void(0);"
                    @click.prevent="printPage"
                  >
                    <i class="ti ti-printer me-1"></i>Print
                  </a>
                </li> -->
              </ul>
            </div>
          </div>

          <div class="head-icons ms-2">
            <a id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="row dq-stat-grid" v-if="summary">
        <!-- KPI Cards -->
        <div
          class="col-xl-3 col-md-6 d-flex mb-3"
          v-for="k in kpiCards"
          :key="k.title"
        >
          <div class="card flex-fill dq-stat-card">
            <div class="card-body">
              <div
                class="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2"
              >
                <div>
                  <span class="fs-14 fw-normal text-truncate mb-1">{{
                    k.title
                  }}</span>
                  <h5 v-if="k.isMoney">
                    {{ currency }}
                    {{
                      Number(k.value || 0).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    }}
                  </h5>
                  <h5 v-else>
                    {{ k.value }}
                  </h5>
                </div>
                <a
                  href="javascript:void(0);"
                  class="avatar avatar-md avatar-rounded"
                  :class="`bg-transparent-${k.cls} border border-${k.cls}`"
                >
                  <span :class="`text-${k.cls}`">
                    <i class="ti ti-report-analytics"></i>
                  </span>
                </a>
              </div>
              <p class="fs-12 fw-normal text-muted mb-0">
                Period: {{ summary.period }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Tables -->
      <div class="row">
        <div class="col-xl-6">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">Statutory Deductions</h5>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-striped mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th>Code</th>
                      <th>Description</th>
                      <th class="text-end">Amount ({{ currency }})</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in statutory" :key="row.code">
                      <td>{{ row.code }}</td>
                      <td>{{ row.label }}</td>
                      <td class="text-end">
                        {{
                          Number(row.amount || 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })
                        }}
                      </td>
                    </tr>
                    <tr v-if="!statutory.length">
                      <td colspan="3" class="text-center text-muted py-3">
                        No data for selected period.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">Other Deductions</h5>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-striped mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th>Code</th>
                      <th>Description</th>
                      <th class="text-end">Amount ({{ currency }})</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in other" :key="row.code">
                      <td>{{ row.code }}</td>
                      <td>{{ row.label }}</td>
                      <td class="text-end">
                        {{
                          Number(row.amount || 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })
                        }}
                      </td>
                    </tr>
                    <tr v-if="!other.length">
                      <td colspan="3" class="text-center text-muted py-3">
                        No data for selected period.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment modes -->
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0">Payment Mode Breakdown</h5>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-striped mb-0">
              <thead class="thead-light">
                <tr>
                  <th>Payment Mode</th>
                  <th class="text-end">Employees</th>
                  <th class="text-end">Net Amount ({{ currency }})</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="pm in paymentModes" :key="pm.mode">
                  <td>{{ pm.mode }}</td>
                  <td class="text-end">{{ pm.employee_count }}</td>
                  <td class="text-end">
                    {{
                      Number(pm.amount || 0).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                </tr>
                <tr v-if="!paymentModes.length">
                  <td colspan="3" class="text-center text-muted py-3">
                    No data for selected period.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 767.98px) {
  .dq-page-actions {
    align-items: stretch !important;
  }

  .dq-page-actions > * {
    width: 100%;
    margin-right: 0 !important;
  }

  .dq-page-actions .form-control,
  .dq-page-actions .dropdown,
  .dq-page-actions .dropdown-toggle {
    width: 100%;
  }

  .dq-stat-card .card-body {
    padding: 1rem;
  }

  .table-responsive {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
  }

  .table-responsive table {
    min-width: 680px;
  }
}
</style>

<script setup>
import { reactive, computed, onMounted } from "vue";
import moment from "moment";
import { useEmployeeSalaryStore } from "@/stores/employeeSalaryStore";

const title = "Payroll Control Totals";
const text = "Administration";
const text1 = "Payroll Control Totals";

const store = useEmployeeSalaryStore();

const filters = reactive({
  period: moment().format("YYYY-MM"),
});

const summary = computed(() => store.controlSummary || null);
const statutory = computed(() => store.controlStatutory || []);
const other = computed(() => store.controlOther || []);
const paymentModes = computed(() => store.controlPaymentModes || []);
const currency = computed(() => summary.value?.currency || "KES");

const kpiCards = computed(() => [
  {
    title: "Total Gross",
    value: summary.value?.total_gross || 0,
    cls: "primary",
    isMoney: true,
  },
  {
    title: "Total Statutory Deductions",
    value: summary.value?.total_statutory || 0,
    cls: "danger",
    isMoney: true,
  },
  {
    title: "Total Other Deductions",
    value: summary.value?.total_other || 0,
    cls: "warning",
    isMoney: true,
  },
  {
    title: "Total Net Pay",
    value: summary.value?.total_net || 0,
    cls: "success",
    isMoney: true,
  },
]);

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

async function fetchReport() {
  await store.fetchPayrollControlTotals({ period: filters.period });
}

function exportCsv() {
  store.exportPayrollControlTotals("csv", { period: filters.period });
}

function exportPdf() {
  store.exportPayrollControlTotals("pdf", { period: filters.period });
}

function printPage() {
  window.print();
}

onMounted(() => {
  fetchReport();
});
</script>


